import { render, staticRenderFns } from "./OverviewMisc.vue?vue&type=template&id=8c60085e&scoped=true"
import script from "./OverviewMisc.vue?vue&type=script&lang=js"
export * from "./OverviewMisc.vue?vue&type=script&lang=js"
import style0 from "./OverviewMisc.vue?vue&type=style&index=0&id=8c60085e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c60085e",
  null
  
)

export default component.exports